module.exports = __webpack_public_path__ + "img/graph-svgrepo-com.d69d17a2.svg";